<template>
  <v-app id="addinpt">
    <v-main>
      <v-container fluid>
        <v-form ref="addInpt" v-model="addInptValid"> 
          <v-row>
            <v-col cols="2">
             <v-select v-model="bedrCodeSelected" :items="bedrCodes" item-value="bedr_code" item-text="bedr_code" label="Company"></v-select>
            </v-col>
            <v-col cols="2">
             <v-text-field v-model="inpt_code" :rules="inpt_codeRules" label="ID" hint="Short unique ID"></v-text-field>
            </v-col>
          </v-row>
           <v-row>
            <v-col cols="2">
             <v-select v-model="landCodeSelected" :items="landCodes" item-value="land_code" item-text="land_code" label="Country"></v-select>
            </v-col>
            <v-col cols="2">
             <v-select v-model="taalCodeSelected" :items="taalCodes" item-value="taal_code" item-text="taal_code" label="Language"></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="!addInptValid" @click="addInpt">Add</v-btn>
            </v-col> 
          </v-row>
        </v-form>
      </v-container>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      addInptValid: false,
      inpt_code: '',
      bedrCodeSelected: '',
      bedrCodes: [],
      landCodeSelected: '',
      landCodes: [],
      taalCodeSelected: '',
      taalCodes: [],
      inpt_codeRules: [
          v => (v && v.length >= 3) || "An ID is required"
      ]
    }    
  },
  created() {
    var deze = this;
    this.$axios
      .post("ares/json/ares/task/inpt/getToAddInpt.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getToAddInpt"
        },
        getToAddInpt: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           res.data.getToAddInpt.forEach(function(inptBedr) {
            deze.bedrCodes.push(inptBedr.bedr_code);
            if(inptBedr.selected === true) {
               deze.bedrCodeSelected = inptBedr.bedr_code;
            }   
          });
          res.data.landKeuzes.forEach(function(land) {
            deze.landCodes.push(land.land_code);
            if(land.selected === true) {
               deze.landCodeSelected = land.land_code;
            }   
          });
          res.data.taalKeuzes.forEach(function(taal) {
            deze.taalCodes.push(taal.taal_code);
            if(taal.selected === true) {
               deze.taalCodeSelected = taal.taal_code;
            }   
          });
        }
      });

  },
  methods: {
     addInpt() {
      this.$axios
        .post("ares/json/ares/task/inpt/addInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addInpt"
          },
          addInpt: {
            bedr_code: this.bedrCodeSelected,
            inpt_code: this.inpt_code,
            land_code: this.landCodeSelected,
            taal_code: this.taalCodeSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
             if (res.data.addInpt.color == "success") { 
                setTimeout(() => { this.$router.open('/task/inpt/onInpt/' + res.data.addInpt.inpt_encrid);  }, 2000);      
                setTimeout(() => { this.$router.reload('/task/inpt/searchInpt');  }, 2000);   
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addInpt.text,
              color: res.data.addInpt.color
            }); 
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};

</script> 
